export default {
  zh: {
    message: '输入的内容不符合Email的格式',
    placeholder: '双击可进行修改',
  },
  en: {
    message: 'The input is not a valid Email.',
    placeholder: 'Double-click to edit',
  },
};



// WEBPACK FOOTER //
// ./src/components/ui/CustomField/i18n.js